var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticStyle:{"width":"100%","height":"90vh"},domProps:{"value":_vm.current_value},on:{"keydown":function($event){return _vm.updateValue($event)},"input":function($event){return _vm.change($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }